var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMediaIcons8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-media-icons8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-library-V2",
    transform: "translate(-21.000000, -436.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-media-icons8",
    transform: "translate(21.500000, 437.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinejoin: "round",
    x: 0,
    y: 0,
    width: 7.6,
    height: 16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.2,
    cy: 3.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.2,
    cy: 12.2,
    r: 3.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMediaIcons8);
export default __webpack_public_path__ + "static/media/icon-media-icons8.b44a15ba6e0ed884eff922df4bfe7e98.svg";
export { ForwardRef as ReactComponent };